'use client';
import { Logo } from 'themes/jumbo/app/_components/_core';
import {
  useJumboLayout,
  useSidebarState,
} from 'themes/jumbo/@jumbo/components/JumboLayout/hooks';
import { useJumboTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import { SIDEBAR_STYLES, SIDEBAR_VIEWS, SIDEBAR_VARIANTS } from 'themes/jumbo/@jumbo/utilities/constants';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { IconButton, Zoom, Tooltip } from '@mui/material';
import React from 'react';
import { SidebarHeaderDiv } from '..';
import { trackEvent } from 'components/Tracking';

function SidebarHeader() {
  const { theme } = useJumboTheme();
  const { sidebarOptions, setSidebarOptions } = useJumboLayout();
  const { isMiniAndClosed } = useSidebarState();
  const miniAndClosed = isMiniAndClosed();

  function handleMenuToggle() {
    setSidebarOptions({ open: false });
    const isVisible = sidebarOptions.open;
    const isMini = sidebarOptions.view === SIDEBAR_VIEWS.MINI || sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY;
    const options = { 
      open: !isVisible && !isMini,
      view: isVisible && !isMini ? SIDEBAR_VIEWS.MINI : SIDEBAR_VIEWS.FULL,
      variant: !(isVisible && !isMini) ? SIDEBAR_VARIANTS.TEMPORARY : SIDEBAR_VARIANTS.PERMANENT,
    }
    setSidebarOptions(options);
    trackEvent("Menu", "Sidebar", isMini ? "Close" : !isVisible ? "Open" : "Mini");
    //localStorage.setItem('userSideBarOptions', JSON.stringify(options));
  }

  return (
    <React.Fragment>
      {sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <SidebarHeaderDiv>
          <Logo mini={miniAndClosed} mode={theme.type} />
          <Zoom in={true} style={{marginRight: sidebarOptions?.view === SIDEBAR_VIEWS.MINI ? '3px' : '0'}}>
            <IconButton
              edge='start'
              color='inherit'
              aria-label='open drawer'
              sx={{ ml: 0, mr: -1.5 }}
              onClick={handleMenuToggle}
            >
              <Tooltip title="Hide sidebar" placement="top" arrow><MenuOpenIcon /></Tooltip>
            </IconButton>
          </Zoom>
        </SidebarHeaderDiv>
      )}
    </React.Fragment>
  );
}

export { SidebarHeader };
